import { FOCUSABLES } from './constants';
export function getFocusables(root) {
    var selected = Array.from(root.querySelectorAll(FOCUSABLES.join(', ')));
    return selected.filter(visible);
}
function visible(elem) {
    return !!(elem.offsetWidth ||
        elem.offsetHeight ||
        elem.getClientRects().length);
}
